import styles from "../../index.module.scss";
import BackBtn from "../../../../assets/images/back_btn.svg";

import { useContext, useEffect, useState } from "react";
import { getTypingStatus } from "../../../../Managers/Chat";
import { networkContext } from "../../../../contexts/NetworkContext/NetworkContextProvider";
import { NameAvatar } from "../../../nameImage";
import closebtnImg from "../../../../assets/images/close.png";
import { UserContext } from "../../../../contexts/UserContext/UserContextProvider";

export const NameReturn = (user) => {
  if (user[user.chatWith]) {
    return user[user.chatWith];
  } else if (user.chatWithName) {
    return user.chatWithName;
  } else if (user.firstName) {
    return `${user.firstName} ${user.lastName}`;
  } else {
    return "N/A";
  }
};

export const ChatSectionHeader = ({ chatUser, webinarId, OnBackfromChat }) => {
  const { roomId } = useContext(networkContext);
    const { setIsChatBotOpen } = useContext(UserContext);
  const [typingStatus, setTypingStatus] = useState(false);

  useEffect(() => {
    getTypingStatus(webinarId, roomId, chatUser?.id, (data) => {
      setTypingStatus(data === true ? true : false);
    });
  }, []);

  return (
    <div className={styles.chatSection__header}>
      <div className={styles.chatSection__header__back__btn}>
        <img
          src={BackBtn}
          alt=""
          onClick={() => OnBackfromChat(chatUser?.id)}
        />
      </div>
      <div
        className={styles.userListBox__userList__user_container}
        style={{ marginBottom: "-0.5rem" }}
      >
        <div className={styles.ChatConnections__user__img}>
          {chatUser.chatUserPhoto ? (
            <img
              src={chatUser?.chatUserPhoto}
              alt="user"
              style={{ width: "3rem", height: "3rem" }}
            />
          ) : (
            <NameAvatar
              width={"3.125rem"}
              height={"3.125rem"}
              firstName={NameReturn(chatUser).split(" ")[0]}
              lastName={NameReturn(chatUser).split(" ")[1]}
              size={"1rem"}
            />
          )}
        </div>
        <div className={styles.ChatConnections__user__name2}>
          <h3>{NameReturn(chatUser)}</h3>
          {typingStatus && <p>typing ...</p>}
        </div>
      </div>
      <div
        className={styles["closeBtn"]}
        onClick={() => setIsChatBotOpen(false)}
      >
        <img width="25px" src={closebtnImg} alt="close" />
      </div>
    </div>
  );
};
